var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tipBottom},[_c('div',{class:_vm.$style.tip},[_vm._v(" 操作提示：点击已部署/已退场楼栋查看设备状态数据 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }